import React from 'react';

import { useFiltersStateManager } from './FiltersStateManager';
import ClearButton from './components/ClearButton';

const ClearFiltersButton = () => {
  const { onClearFilters, clear } = useFiltersStateManager();

  return <ClearButton onClick={onClearFilters} disabled={!clear} />;
};

export default ClearFiltersButton;
